'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_PAYMENT_METHOD = exports.PAYMENT_METHOD_COMPONENTS = exports.DEFAULT_PAYMENT_METHOD_ID = exports.STRIPE_PAYMENT_METHODS = undefined;

var _PaymentMethods = require('components/PaymentMethods');

var STRIPE_PAYMENT_METHODS = exports.STRIPE_PAYMENT_METHODS = {
  CARD: 'card',
  SEPA: 'sepa'
};

var DEFAULT_PAYMENT_METHOD_ID = exports.DEFAULT_PAYMENT_METHOD_ID = STRIPE_PAYMENT_METHODS.CARD;

var PAYMENT_METHOD_COMPONENTS = exports.PAYMENT_METHOD_COMPONENTS = {
  card: _PaymentMethods.CardPaymentFormContainer,
  sepa: _PaymentMethods.SEPAPaymentFormContainer
};

var DEFAULT_PAYMENT_METHOD = exports.DEFAULT_PAYMENT_METHOD = {
  component: PAYMENT_METHOD_COMPONENTS[DEFAULT_PAYMENT_METHOD_ID],
  id: DEFAULT_PAYMENT_METHOD_ID,
  rank: 1
};